// @korvo-app-router-pattern: AL
'use client'
import { useState } from 'react'

export default function PasswordRequestPage() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')
  const [devToken, setDevToken] = useState('')

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setSent(false)
    setDevToken('')
    const res = await fetch('/api/auth/password/request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    })
    if (!res.ok) {
      setError('Failed to request reset')
      return
    }
    const data = await res.json().catch(() => ({})) as { devToken?: string }
    setDevToken(typeof data.devToken === 'string' ? data.devToken : '')
    setSent(true)
  }

  return (
    <div className="min-h-screen flex items-center justify-center text-foreground py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6">
        <h2 className="text-center text-2xl font-semibold text-foreground">Reset your password</h2>
        <form onSubmit={(e) => { void submit(e) }} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground">Email</label>
            <input className="mt-1 block w-full px-3 py-2 border border-border rounded-md bg-background-secondary text-foreground placeholder-foreground-muted focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary focus:ring-offset-2 focus:ring-offset-background" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <button className="w-full py-2 rounded-md bg-primary hover:bg-primary-hover text-primary-foreground focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary focus:ring-offset-background transition-colors">Send reset link</button>
        </form>
        {sent && (
          <div className="text-sm korvo-text-success korvo-bg-success-opacity-10 border border-success p-3 rounded">If the email exists, a reset link was sent.</div>
        )}
        {error && <div className="text-sm korvo-text-danger korvo-bg-danger-opacity-10 border border-danger p-3 rounded">{error}</div>}
        {devToken && (
          <div className="text-xs text-foreground-muted">Dev token: {devToken}. Use it on the reset page.</div>
        )}
      </div>
    </div>
  )
}


